import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStylesBase = makeStyles((theme: Theme) => ({
  paper: {
    backgroundColor:
      theme.palette.mode === 'dark' ? '#121c21 !important' : '#fff',
    marginBottom: theme.spacing(3),
  },
  sectionContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(7),
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0),
  },
  subsectionTitle: {
    fontSize: '16px',
    textTransform: 'uppercase',
    color: '#999',
  },
  subsectionDivider: {
    flex: '0 0 100%',
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  topSection: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  topContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: 0,
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(7),
  },
  topDivider: {
    borderTop: '3px solid rgba(18, 20, 22, 0.1)',
    marginBottom: theme.spacing(1),
  },
  statsLabel: {
    fontSize: '10px',
    textTransform: 'uppercase',
    color: 'grey',
  },
  statsValue: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  statsValueLoading: {
    backgroundColor: theme.palette.mode === 'dark' ? 'dimgray' : 'gainsboro',
    width: '80px',
    height: '30px',
  },
  editButtonContainer: {
    textAlign: 'center',
  },
  editAllLink: {
    float: 'right',
    '& span': {
      color: theme.palette.mode === 'dark' ? '#FFF' : '#000',
    },
  },
  editLink: {
    float: 'right',
    marginRight: '11px',
  },
  audioPlayer: {
    transform: 'scale(0.7)',
    transformOrigin: '0 0',
  },
}));
